import React, { Component, cloneElement, PropTypes } from 'react';
import ContractingWindow from './draftNTemplate-window';
import AddEditContractDialog from './add-edit-contract-dialog';
import R from 'ramda';
import PublishDraftDialog from './publish-draft-dialog';
import { connect } from 'react-redux';
import ProgressIndicator from './progressIndicatorBar/progressIndicatorContainer';
import WaterMark from '../watermark';
import DraftSnackbar from './draft-snackbar';
import { toLaxTitleCase } from 'titlecase';
import { checkLocAccess } from '../../../../middleware/accessCheckHelperFns';
import {
  getContractLeftNav as getContractLeftNavAction,
  deleteProductFromContract as deleteProductFromContractAction,
  checkContractReadiness as checkContractReadinessAction,
  downloadContractPdf as downloadContractPdfAction,
  openImportFromOtherProductsDialog as openImportFromOtherProductsDialogAction,
  sortingProducts as sortingProductsAction,
  clearStore as clearStoreAction,
  reloadContentInBg as reloadContentInBgAction,
  createDraft,
  toggleDraftErrorsDialog as toggleDraftErrorsDialogAction,
} from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import { changeContractState as changeContractStateAction } from '../../../../stores/contracting/dashboard/dashboard-actions';
import {
  saveProductInfoChanges as saveProductInfoChangesAction,
  publishDraft as publishDraftAction,
} from '../../../../stores/contracting/dialogs/dialog-constants';
import ResendContract from '../contract-container/dialogs/resend-or-update-dialog';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import CreateDraftDialog from './dialog-create-template-draft';
import { FlatButton, RaisedButton } from 'material-ui';
const propTypes = {
  children: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  wizard: PropTypes.object,
  contentLoading: PropTypes.bool,
  refreshing: PropTypes.bool,
  errorOccurs: PropTypes.string,
  leftNav: PropTypes.object,
  rightSideContent: PropTypes.object,
  params: PropTypes.object,
  changeContractStateTo: PropTypes.func,
  openAddEditContractDialog: PropTypes.func,
  checkContractReadiness: PropTypes.func,
  deleteProductFromContract: PropTypes.func,
  askIfWantToCheckReadiness: PropTypes.func,
  getContractLeftNav: PropTypes.func,
  openDialogSaveAsTemplate: PropTypes.func,
  downloadContractPdf: PropTypes.func,
  openImportFromOtherProductsDialog: PropTypes.func,
  dispatchedSortingProducts: PropTypes.func,
  saveProductInfoChangesDispatched: PropTypes.func,
  toggleDraftErrorsDialog: PropTypes.func,
  clearStore: PropTypes.func,
  leftNavLoading: PropTypes.bool,
  publishDraft: PropTypes.func,
  goToSendUpdates: PropTypes.func,
  draftComplete: PropTypes.bool,
  toggleCreateDraftDialog: PropTypes.func,
  createDraftDialogOpen: PropTypes.bool,
  readOnly: PropTypes.bool,
  noAccess: PropTypes.bool,
  reloadContentInBg: PropTypes.func,
  openPublishConfirmation: PropTypes.func,
  previousRoute: PropTypes.string,
  isDummyAccount: PropTypes.bool,
  isAnAdmin: PropTypes.bool,
  jumpBackTo: PropTypes.string,
  magicLinkHashToken: PropTypes.string,
  pureDocView: PropTypes.bool,
};
const getMainTitle = (partnerCompanyName, locationName, templateName) => {
  const flipConcat = R.flip(R.concat);
  const lengthGt = gtNum => R.compose(R.lt(gtNum), R.length);
  const composeThreeDotsString = gtNum => R.ifElse(
    lengthGt(gtNum),
    R.compose(flipConcat('...'), R.slice(0, gtNum)),
    R.slice(0, gtNum)
  );
  const composeString = (a, b) => `${a}${a && b ? ' / ' : ''}${b}`;
  return R.useWith(composeString, [composeThreeDotsString(50), composeThreeDotsString(23)])(locationName, templateName || partnerCompanyName);
};
/*
 @params pathname = route || location.pathname
 */
const getRouteName = R.cond([
  [R.contains('activities'), R.always('activities')],
  [R.contains('product'), R.always('product')],
  [R.contains('partners'), R.always('partners')],
  [R.contains('logs'), R.always('logs')],
  [R.contains('policies'), R.always('policies')],
  [R.T, R.always('contractDetails')],
]);

class DraftNTemplateContainer extends Component {

  componentDidMount() {
    const { dispatch, getContractLeftNav, params } = this.props;
    dispatch({ type: 'CLOSE_PUBLISH_DRAFT_DIALOG' });
    getContractLeftNav(params.collection, params.contractId)
    .then(this.routeToFirstProduct);
  }
  componentWillReceiveProps(nextProps) {
    const { leftNav, getContractLeftNav, params } = nextProps;
    if (params !== this.props.params || this.props.location.query !== nextProps.location.query) {
      if (params.collection !== this.props.params.collection || params.contractId !== this.props.params.contractId || nextProps.location.query.refresh === 'true') {
        getContractLeftNav(params.collection, params.contractId)
        .then(this.routeToFirstProduct);
      }
    }
    if (this.props.leftNav.locationName !== leftNav.locationName || this.props.leftNav.templateName !== leftNav.templateName) {
      const collection = params.collection;
      document.title = `${getMainTitle(leftNav.companyName || '', leftNav.locationName || '', leftNav.templateName || '')} - ${toLaxTitleCase(collection)} - TourConnect`;
    }
  }

  routeToFirstProduct = (newLeftNav) => {
    const { location, params } = this.props;
    // AUTO route user to the first product page
    const routeName = getRouteName(location.pathname);
    if (routeName === 'contractDetails') {
      const firstProduct = R.path(['payload', 'productsArray', 0], newLeftNav);
      if (!firstProduct) this.context.router.replace(location.pathname.replace('details', 'policies'));
      else {
        const ratePackageId = (() => {
          if (firstProduct._id) return firstProduct._id;
          return firstProduct.ratePackageName
          ? encodeURIComponent(firstProduct.ratePackageName)
          : 'Primary';
        })();
        this.context.router.replace(`/contracting/${params.collection}/${params.contractId}/product/${firstProduct.productId}/${ratePackageId}`);
      }
    }
  };
  reloadContent = () => {
    const { params, reloadContentInBg } = this.props;
    reloadContentInBg({
      collection: params.collection,
      contractId: params.contractId,
      productId: params.productId,
      ratePackage: params.ratePackage,
    });
  }
  changeLeftNavRoute = (route) => {
    const { location } = this.props;
    const { router } = this.context;
    if (location.pathname !== route) {
      router.replace(route);
    }
  };

  createNGoToDraft = () => {
    const { leftNav, location } = this.props;
    const routeName = getRouteName(location.pathname);
    if (leftNav.templateHasDraft) {
      const newRoute = (routeName !== 'activities' || routeName === 'partners') ?
        location.pathname.replace('/template/', '/draft/') : `/contracting/draft/${leftNav.contractId}/details`;
      this.context.router.replace(newRoute);
    }
    else this.props.toggleCreateDraftDialog();
  };
  render() {
    const { router } = this.context;
    const {
      previousRoute,
      children,
      params,
      contentLoading,
      leftNavLoading,
      refreshing,
      errorOccurs,
      leftNav,
      rightSideContent,
      openAddEditContractDialog,
      changeContractStateTo,
      openDialogSaveAsTemplate,
      downloadContractPdf,
      openImportFromOtherProductsDialog,
      dispatchedSortingProducts,
      saveProductInfoChangesDispatched,
      isDummyAccount,
      isAnAdmin,
      magicLinkHashToken,
      pureDocView,
    } = this.props;
    const { productId, contractId } = params;
    const { location } = this.props;
    const isADraft = leftNav.contractState === 'draft' || leftNav.contractState === 'publish-ready';
    const routeName = getRouteName(location.pathname);
    const loading = leftNavLoading || contentLoading;
    const extraProps = {
      reducerName: 'contractActivitiesProducts',
      reloadContent: this.reloadContent,
      openAddEditContractDialog: leftNav.supplierEditable ? openAddEditContractDialog : () => {
        const confirmed = window.confirm('Would you like create a draft for editing?');
        if (confirmed) this.createNGoToDraft();
      },
      productDoesnotExistInDoc: (routeName === 'product' && !loading && R.isNil(rightSideContent.ratePackageIndex)),
      deleteFromProduct: extraPayload => saveProductInfoChangesDispatched(R.merge({ contractId, productId }, extraPayload)),
    };
    const propsForLeftNav = {
      reducerName: extraProps.reducerName,
      location: this.props.location,
      changeLeftNavRoute: this.changeLeftNavRoute,
      goToDashboard: () => {
        if (this.props.jumpBackTo) window.location = this.props.jumpBackTo;
        else if (previousRoute) router.goBack();
        else router.push(`/contracting/template-list`);
      },
      changeContractStateTo,
      openAddEditContractDialog: extraProps.openAddEditContractDialog,
      sortingProducts: dispatchedSortingProducts(contractId),
      openDialogSaveAsTemplate,
      toggleDraftErrorsDialog: this.props.toggleDraftErrorsDialog,
    };
    const propsForMenu = {
      productId,
      contractId,
      locationId: leftNav.locationId,
      router,
      openAddEditContractDialog: extraProps.openAddEditContractDialog,
      openImportFromOtherProductsDialog,
      openDialogSaveAsTemplate,
    };
    const shouldHideAppBars = (isDummyAccount && !isAnAdmin)
    || pureDocView;
    return (
      <div
        className={shouldHideAppBars ? 'full-screen-page' : ''}
        style={shouldHideAppBars ? { padding: '0 128px' } : {}}
      >
        {
          Boolean(this.props.readOnly && !loading && leftNav.isLatest) && (<div style={{ textAlign: 'center', marginBottom: '8px', fontWeight: 'bold' }}>
            This {this.props.params.collection === 'draft' ? 'Draft' : 'Template'} is READ-ONLY.
          </div>)
        }
        <ProgressIndicator
          isADraft={this.props.params.collection === 'draft'}
          contractId={contractId}
          isDummyAccount={isDummyAccount}
        />
        <ContractingWindow
          reducerName={extraProps.reducerName}
          actionsForLeftNav={propsForLeftNav}
          actionsForMenu={propsForMenu}
          productDoesnotExistInDoc={extraProps.productDoesnotExistInDoc}
          actionsForContractWindow={{
            deleteProductFromContract: this.props.deleteProductFromContract,
            downloadContractPdf,
            changeLeftNavRoute: this.changeLeftNavRoute,
            openDialogSaveAsTemplate,
            createNGoToDraft: this.createNGoToDraft,
            publishDraftWithRouting: this.props.publishDraft,
          }}
          getMainTitle={getMainTitle}
        >
          {
            Boolean(leftNav.stagedUpdates && leftNav.stagedUpdates.some(obj => obj.source === 'draft')) && (
              <WaterMark texts={['Queued for Updates', 'Queued for Updates', 'Queued for Updates', 'Queued for Updates']} />
            )
          }
          {
            Boolean(!leftNav.isLatest && !loading) && (<WaterMark texts={['Old Version', 'Old Version', 'Old Version', 'Old Version']} />)
          }
          {children && !errorOccurs ? cloneElement(children, extraProps) : undefined}
          <ResendContract />
          <AddEditContractDialog
            reducerName={extraProps.reducerName}
            router={this.context.router}
            reloadContent={this.reloadContent}
          />
          <PublishDraftDialog
            reducerName={extraProps.reducerName}
            goToDashBoard={propsForLeftNav.goToDashboard}
            changeLeftNavRoute={this.changeLeftNavRoute}
          />
          {
            isADraft && !pureDocView ? (
              <DraftSnackbar
                leftNav={leftNav}
                goToSendUpdates={this.props.goToSendUpdates}
                checkContractReadiness={this.props.toggleDraftErrorsDialog}
                publishDraftWithRouting={this.props.publishDraft}
                draftComplete={this.props.draftComplete}
                openPublishConfirmation={this.props.openPublishConfirmation}
                isDummyAccount={isDummyAccount}
              />
            ) : <div/>
          }
          <CreateDraftDialog
            open={this.props.createDraftDialogOpen}
            sentPartners={leftNav.sentPartners}
            isDummyAccount={isDummyAccount}
            createTemplateDraft={() => {
              this.props.toggleCreateDraftDialog();
              createDraft(contractId, contractId, true)
                .then(() => this.context.router.replace(`/contracting/draft/${contractId}/details`));
            }}
            onRequestClose={this.props.toggleCreateDraftDialog}
          />
        </ContractingWindow>
        <LoadingOverlay
          loading={refreshing}
        />
        <div
          className="full-screen-page"
          style={{
            display: Boolean(errorOccurs) ? 'block' : 'none',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            textAlign: 'center',
            paddingTop: '20%',
          }}
        >
          <div style={{ fontSize: '20px', color: 'white', marginTop: '24px', whiteSpace: 'pre-wrap', width: '50%', margin: 'auto', lineHeight: '24px' }}>
            {(() => {
              if (errorOccurs === 'An Error Occurred') {
                return (
                  <div style={{ marginTop: '100px', textAlign: 'center' }}>
                    Oops, an error occured, please <a style={{ cursor: 'pointer' }} onClick={router.goBack}>go back</a> and try again.
                    <div style={{ marginTop: '16px', fontSize: '12px' }}>If this happens again, please reach out to our support team on support@tourconnect.com.</div>
                  </div>
                );
              } else if (errorOccurs) {
                if (magicLinkHashToken) {
                  return (
                    <div>
                      {errorOccurs}
                      <div style={{ marginTop: '24px' }}>
                        <RaisedButton
                          label="REOPEN THIS RATE SHEET"
                          secondary
                          onClick={() => window.location = `${process.env.SECONDARY_SYSTEM_URL}/assets-landing?hashToken=${magicLinkHashToken}`}
                        />&nbsp;&nbsp;
                        <FlatButton
                          label="CLOSE THIS TAB"
                          primary
                          onClick={() => window.close()}
                        />
                      </div>
                    </div>
                  )
                }
                return errorOccurs;
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

DraftNTemplateContainer.propTypes = propTypes;

const mapStateToProps = ({ contracting, user, route, dummyAcct }) => {
  const contractStore = contracting.contractActivitiesProducts;
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  const readOnly = !checkLocAccess({ user }, leftNav.locationId, 'contracting', 'write');
  const noAccess = !checkLocAccess({ user }, leftNav.locationId, 'contracting', 'read');
  return ({
    readOnly,
    noAccess,
    contentLoading: contractStore.get('contentLoading'),
    leftNavLoading: contractStore.get('leftNavLoading'),
    refreshing: contractStore.get('refreshing'),
    createDraftDialogOpen: contractStore.get('createDraftDialogOpen'),
    draftComplete: !contractStore.toJS().draftErrors.errorExist,
    errorOccurs: contractStore.get('errorOccurs'),
    leftNav,
    rightSideContent: contractStore.get('rightSideContent') ? contractStore.get('rightSideContent').toJS() : contractStore.get('rightSideContent'),
    routeName: contractStore.get('routeName'),
    billingPlan: user.get('billingPlan'),
    previousRoute: route.previousRoute,
    isDummyAccount: user.get('isDummyAccount'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView'),
    ...dummyAcct.dummyTemplate,
  });
};

const mapDispatchToProps = (dispatch, state) => ({
  clearStore: () => dispatch(clearStoreAction()),
  getContractLeftNav: (...args) => dispatch(getContractLeftNavAction(...args)),
  deleteProductFromContract: (contractId, ratePackageIndex, productName) => dispatch(deleteProductFromContractAction({ contractId, ratePackageIndex, productName })),
  changeContractStateTo: (state, ids) => dispatch(changeContractStateAction(state, ids)),
  goToSendUpdates: () => dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' }),
  checkContractReadiness: (contractId) => dispatch(checkContractReadinessAction(contractId)),
  openAddEditContractDialog: payload => {
    dispatch({ type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload });
  },
  openDialogSaveAsTemplate: (contractId, contractYear) => {
    dispatch({ type: 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE', payload: { contractId, contractYear } });
  },
  downloadContractPdf: (...args) => dispatch(downloadContractPdfAction(...args)),
  openImportFromOtherProductsDialog: (...args) => dispatch(openImportFromOtherProductsDialogAction(...args)),
  dispatchedSortingProducts: R.curry((contractId, products) => dispatch(sortingProductsAction(contractId, products))),
  saveProductInfoChangesDispatched: (...args) => dispatch(saveProductInfoChangesAction(...args)),
  publishDraft: (...args) => dispatch(publishDraftAction(...args)),
  toggleDraftErrorsDialog: (...args) => dispatch(toggleDraftErrorsDialogAction(...args)),
  toggleCreateDraftDialog: () => dispatch({ type: '[contractTemplate]TOGGLE_CREATE_DRAFT_DIALOG' }),
  reloadContentInBg: (...args) => dispatch(reloadContentInBgAction(...args)),
  openPublishConfirmation: () => dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { open: true, title: 'Finalise Template' } }),
});

DraftNTemplateContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DraftNTemplateContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/draftNTemplate-container.jsx